import Axios from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import moment from 'moment'
import { FaEye, FaCalculator } from 'react-icons/fa';
import Header from '../components/Header';
import InfoList from '../components/InfoList';
import { Shared } from '../components/Shared';

export const Detail = ({ match, ...props }) => {
    const { id } = (match.params);
    const [data, setData] = useState({
        title: '',
        hits: 0,
        fjname: '',
        fujian: '',
        date: '',
        content: '',
    });
    const [cate, setCate] = useState({
        id: 0,
        name: ''
    });
    const [more, setMore] = useState([]);
    const contentRef = useRef(null)
    const loadData = async () => {
        let res = await Axios.get(`/api/info/detail/${id}`);
        setData(res.data.info);
        setCate(res.data.cate);
        setMore(res.data.more);
        contentRef.current.innerHTML = res.data.info.content;
        let html = res.data.info.content;
        if(html && /^http[s]*:/ig.test(html)){
            window.location=html;
        }
    }
    const buildHitAndDate = () => {
        return (
            <div className='more-info'>
                <span>

                    <FaEye size={12} color='gray' />
                    {data.hits}
                </span>
                <span>
                    <FaCalculator size={12} />
                    {moment(data.date).format('YYYY-MM-DD')}
                </span>

            </div>
        )
    };
    useEffect(() => {
        loadData();
    }, [id])
    return (
        <>

            <div className='detail-wrap'>
                <h1>{data.title}</h1>
                <div>
                    <Shared title={`${data.title}-嘉兴考试培训网`} />
                </div>
                {data.title.length > 0 && buildHitAndDate()}
                <div ref={contentRef} className='mt-2' />
            </div>
            <div className='mt-2'>
                <Header title={cate.name} to={`/list/${cate.id}`} />
                <div>
                    <InfoList list={more} />
                </div>
            </div>
        </>
    )
}
